import InteractEvent from '../entities/InteractEventTracker';
import IInteractEvent from '../entities/IInteractEventTracker';

export interface IInteractEventTrackerState {
  interactEventTracker: IInteractEvent;
  loading: boolean;
}

export default {
  interactEventTracker: new InteractEvent(),
  loading: false,
} as IInteractEventTrackerState;
